let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fwHzn")).then(() => parcelRequire('cGGik'));